// Import model
import { StartCompanyAskSyntheaRequest } from '../models/StartCompanyAskSyntheaRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartCompanyAskSyntheaRequest - handles JSON serialization and deserialization with type validation
 */
export class StartCompanyAskSyntheaRequestSerializer {
  /**
   * Deserializes a JSON string into a StartCompanyAskSyntheaRequest instance
   */
  static deserialize(json: string): StartCompanyAskSyntheaRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartCompanyAskSyntheaRequest instance
   */
  static fromObject(obj: any): StartCompanyAskSyntheaRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartCompanyAskSyntheaRequest');
    }


    const instance: StartCompanyAskSyntheaRequest = {
      assistantId: obj['AssistantId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartCompanyAskSyntheaRequest instances
   */
  static deserializeArray(json: string): StartCompanyAskSyntheaRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartCompanyAskSyntheaRequest instance to a JSON string
   */
  static serialize(instance: StartCompanyAskSyntheaRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartCompanyAskSyntheaRequest instance to a plain object
   */
  static toObject(instance: StartCompanyAskSyntheaRequest): any {
    return {
      'AssistantId': instance.assistantId,
    };
  }

  /**
   * Serializes an array of StartCompanyAskSyntheaRequest instances to a JSON string
   */
  static serializeArray(instances: StartCompanyAskSyntheaRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
